<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <!-- Header -->
    <student-header [showYearSelector]="true" [showAllYearOption]="true" [pageTitle]="pageTitle" class="flex-header">
    </student-header>

    <!-- Content -->
    <div class="flex-content" style="height:100%;">
        <!-- No Data Notice -->
        <div style="text-align: center;" *ngIf="teams && teams.length == 0">
            <p translate>
                No Activities data exists for student
            </p>
        </div>

        <!-- Teams Table -->
        <mat-table [dataSource]="tableData" *ngIf="tableData && teams && teams.length > 0" matSort matSortDisableClear
            matSortActive="Name" matSortDirection="asc">
            <!-- Team Name Column -->
            <ng-container matColumnDef="Name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span *ngIf="showStudentTeams" translate>Team Name</span>
                    <span *ngIf="!showStudentTeams" translate>Activity</span>
                    <filter class="mat-filter" [data]="tableData" columnName="Name" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let team">
                    {{team.Name}}
                </mat-cell>
            </ng-container>

            <!-- Details Column -->
            <ng-container matColumnDef="Details">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Details</span>
                    <filter class="mat-filter" [data]="tableData" columnName="Details" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let team">
                    {{team.Details}}
                </mat-cell>
            </ng-container>

            <!-- Entry Date Column -->
            <ng-container matColumnDef="Entry">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span *ngIf="!showStudentTeams" translate>Date</span>
                    <span *ngIf="showStudentTeams" translate>Entry Date</span>
                    <filter class="mat-filter" [data]="tableData" columnName="Entry" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let team">
                    {{team.Entry.toString() != junkDate.toString() ? (team.Entry | date: 'MM/dd/yy') : ''}}
                </mat-cell>
            </ng-container>

            <!-- Exit Date Column -->
            <ng-container matColumnDef="Exit">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Exit Date</span>
                    <filter class="mat-filter" [data]="tableData" columnName="Exit" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let team">
                    {{team.Exit.toString() != junkDate.toString() ? (team.Exit | date: 'MM/dd/yy') : ''}}
                </mat-cell>
            </ng-container>

            <!-- Staff Name Column -->
            <ng-container matColumnDef="Staff">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Staff Name</span>
                    <filter class="mat-filter" [data]="tableData" columnName="Staff" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let team">
                    {{team.Staff}}
                </mat-cell>
            </ng-container>

            <!-- Comment Column -->
            <ng-container matColumnDef="Comment">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Comment</span>
                    <filter class="mat-filter" [data]="tableData" columnName="Comment" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let team">
                    {{team.Comment}}
                </mat-cell>
            </ng-container>

            <!-- Row Definitions -->
            <mat-header-row *matHeaderRowDef="showStudentTeams ? shownTeamColumns : hiddenTeamColumns; sticky: true">
            </mat-header-row>
            <mat-row
                *matRowDef="let row; columns: showStudentTeams ? shownTeamColumns : hiddenTeamColumns; let i = index;"
                [ngClass]="{'selectedRow': selectedRow == row}" matRipple>
            </mat-row>
        </mat-table>
    </div>
</tyl-kendo-pdf-export>

<!-- Footer -->
<div class="flex-footer">
    <!-- Left -->
    <div class="flex-footer-left">
    </div>
    <!-- Middle -->
    <div class="flex-footer-middle" style="align-items: center">
        <filter-notification [filtered]="tableData.isFiltered()"
            (clearFilter)="tableData.removeAllFilters(); changeDetector.detectChanges();"></filter-notification>
    </div>
    <!-- Right buttons -->
    <div class="flex-footer-right">
        <mat-checkbox [(ngModel)]="includeInactiveTeams" style="padding-top: 24px; padding-right: 24px;"
            *ngIf="showStudentTeams" translate>Include Inactive Teams</mat-checkbox>
    </div>
</div>